import { getUserInfo, setUserInfo, logout, getUserStatus } from '@/utils/auth'
import router from '@/router/'
import { baseApi } from '@/api'
const actions = {
    // 更新用户实名信息
    async refreshRealStatus () {
      let status = getUserStatus()
      await baseApi.getRealRegisterStatus()
      setUserInfo(Object.assign(getUserInfo(), { status }))
    },
    // 获取用户信息
    getUserInfo,
    // 设置用户信息
    setUserInfo ({ commit }, user) {
      commit('SET_USER', user)
    },
    // 修改用户信息
    updateUser ({ commit, state }, fields) {
      commit('SET_USER', { ...state.info, ...fields })
    },
    // 退出登录
    logout ({ commit }) {
      commit('LOGOUT')
    }
}

const state = () => ({
  isLogin: false,
  info: {}
})

const mutations = {
  SET_USER (state, user) {
    state.info = user
    state.isLogin = true
  },
  LOGOUT (state) {
    state.info = {}
    state.isLogin = false
    logout()
    router.replace({
      path: '/login',
      query: {
        redirect: window.location.href
      }
    })
  }
}

export default {
  actions,
  state,
  mutations
}